<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div style="margin: 10px 0 10px 10px;">
          <div>
            <el-button v-if="!isEdit" v-permission="['button_AviationExchange_aviationExchangeConfig']" type="primary" @click="toEdit">{{ $t('CargoMsg.Cargo_EditTo') }}</el-button>
            <el-button v-if="isEdit" type="primary" @click="toCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
            <el-button v-if="isEdit" type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          </div>
          <div style="margin-top: 10px;">
            <span style="margin: 0 5px 0 10px;">{{ $t('CargoMsg.Cargo_SetBranch') }}</span>
            <el-select v-model="form.branchId" filterable @change="changeBranchId">
              <el-option v-for="(item,index) in officeList" :key="index" :label="getOfficeLabel(item)" :value="item.officeId" />
            </el-select>
            <span v-if="form.branchId !== 1">
              <el-checkbox :value="form.useHqSet" style="margin: 0 5px 0 15px;" :disabled="!isEdit" @input="onUseHqSetInput(!form.useHqSet)" />
              <span>{{ $t('CargoMsg.Cargo_FollowHQ') }}</span>
            </span>
          </div>
        </div>
        <div class="tabs-container" style="position: relative;">
          <el-tabs v-model="activeTabName" type="card" style="width:100%;margin-left: 10px;" @tab-click="handleTabClick">
            <el-tab-pane :key="1" :label="$t('CargoMsg.Cargo_DeclarationScope')" name="tabDeclarationScope">
              <tab-declaration-scope ref="tabDeclarationScope" :is-edit="isEdit" :use-hq-set="form.useHqSet" :branch-id="form.branchId" />
            </el-tab-pane>
            <el-tab-pane :key="2" :label="$t('CargoMsg.Cargo_AlertNotification')" name="tabAlarmNotification">
              <tab-alarm-notification ref="tabAlarmNotification" :is-edit="isEdit" :use-hq-set="form.useHqSet" :branch-id="form.branchId" />
            </el-tab-pane>
            <el-tab-pane :key="3" :label="$t('CargoMsg.Cargo_RPASettings')" name="tabRpaSettings">
              <tab-rpa-settings ref="tabRpaSettings" :is-edit="isEdit" :use-hq-set="form.useHqSet" :branch-id="form.branchId" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import TabDeclarationScope from '@/views/cargo/v0/SystemMaintenance/components/aviationExchangePriceBatch/tab/tabDeclarationScope.vue'
import TabAlarmNotification from '@/views/cargo/v0/SystemMaintenance/components/aviationExchangePriceBatch/tab/tabAlarmNotification.vue'
import TabRpaSettings from '@/views/cargo/v0/SystemMaintenance/components/aviationExchangePriceBatch/tab/tabRpaSettings.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getAviationExchangePriceByOffice, saveAviationExchangePrice } from '@/api/sysManage/aviationExchangePrice'
import { TabError } from '@/utils/class/TabError'

export default {
  name: 'AviationExchangePriceBatchConfig',
  components: { TabDeclarationScope, TabAlarmNotification, TabRpaSettings },
  data() {
    return {
      result: [],
      officeConfigLabel: '',
      officeList: [],
      isEdit: false,
      activeTabName: 'tabDeclarationScope',
      pendTabSet: new Set(),
      form: {
        uuid: '',
        branchId: this.$store.getters.currentOfficeId,
        useHqSet: false
      }
    }
  },
  computed: { },
  async created() {
    const configs = this.$store.state.settings.partnerLabelSettings
    const officeConfig = configs.find(config => config.autoKey === 'auto_office')
    this.officeConfigLabel = Object.keys(officeConfig).find(key => typeof officeConfig[key] === 'boolean' && officeConfig[key])
    this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office)
    await this.loadData()
  },
  methods: {
    getOfficeLabel(item) {
      switch (this.officeConfigLabel) {
        case 'chineseName':
          return item.chineseName
        case 'englishName':
          return item.englishName
        default:
          return item.code
      }
    },
    onUseHqSetInput(val) {
      this.form.useHqSet = val
    },
    async handleTabClick() {
      const oldSize = this.pendTabSet.size
      this.pendTabSet.add(this.activeTabName)
      const isRefresh = this.pendTabSet.size > oldSize
      await this.$refs[this.activeTabName].onShow(this.form, isRefresh)
    },
    toEdit() {
      this.isEdit = true
      this.pendTabSet.clear()
      this.$nextTick(() => {
        this.handleTabClick()
      })
    },
    changeBranchId() {
      this.pendTabSet.clear()
      this.loadData()
    },
    toCancel() {
      this.isEdit = false
      this.changeBranchId()
    },
    async toSave() {
      const loading = getLoading4Cxt(this)
      try {
        const body = {
          branchId: this.form.branchId,
          useHqSet: this.form.useHqSet
        }
        const tabNames = [...this.pendTabSet]
        for (const item of tabNames) {
          const getSubmitData = this.$refs[item].getSubmitData
          if (getSubmitData && typeof getSubmitData === 'function') {
            let tabData = null
            const result = this.$refs[item].getSubmitData()
            if (result instanceof Promise) {
              tabData = await result
            } else {
              tabData = result
            }
            Object.assign(body, tabData)
          }
        }
        console.log('body', body)
        await saveAviationExchangePrice(body).then(res => {
          if (res.ok) {
            this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
            this.isEdit = false
            this.loadData()
          }
        }).catch(err => {
          this.$message.error(err.message || this.$t('CargoMsg.Cargo_SaveFailed'))
        })
      } catch (err) {
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      } finally {
        loading.close()
      }
    },
    async loadData() {
      const loading = getLoading4Cxt(this)
      await getAviationExchangePriceByOffice({ officeId: this.form.branchId }).then(res => {
        const data = res.data
        if (data) {
          this.form.uuid = data.uuid
          this.form.branchId = data.branchId
          this.form.useHqSet = data.useHqSet
        } else {
          this.form.uuid = ''
          this.form.useHqSet = false
        }
        this.handleTabClick()
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>
